export default __webpack_public_path__ + "static/media/lb-sa.77335822.webp";